import { useState } from "react";
import { useTranslation } from "react-i18next";
import { addressMapUrl } from "./addresses.api";

// Where an address lies, to see that it is the right place (docs/address-validation.md,
// decision S29). HERE draws the map and the API passes it on, so the key stays on the
// server; nothing is kept. Without a map — no HERE locally, or HERE not answering —
// the coordinates still show.

export function AddressMap({ lat, lng, label }: { lat: number; lng: number; label: string }) {
  const { t } = useTranslation();
  const src = addressMapUrl(lat, lng);
  // The source that failed: another position tries again.
  const [failed, setFailed] = useState<string | null>(null);
  const unavailable = failed === src;

  return (
    <figure style={{ margin: 0 }}>
      {unavailable ? (
        <div
          className="t-caption t-muted"
          style={{ padding: "12px 16px", background: "var(--surface-subtle)", border: "1px solid var(--border-subtle)", borderRadius: "var(--radius-md)" }}
        >
          {t("addresses.mapUnavailable")}
        </div>
      ) : (
        <img
          src={src}
          alt={t("addresses.mapAlt", { label })}
          onError={() => setFailed(src)}
          style={{
            display: "block",
            width: "100%",
            height: "auto",
            aspectRatio: "720 / 320",
            border: "1px solid var(--border-subtle)",
            borderRadius: "var(--radius-md)",
            background: "var(--surface-subtle)",
          }}
        />
      )}
      <figcaption className="wl-field__help" style={{ marginTop: "6px" }}>
        {!unavailable && `${t("addresses.mapHelp")} `}
        <span className="t-mono">
          {lat.toFixed(5)}, {lng.toFixed(5)}
        </span>
      </figcaption>
    </figure>
  );
}
